export const iconFontAwesomeMathematicsCircleXmark = (
	<i className="fa-solid fa-circle-xmark"></i>
);
